import DeleteTooltip from './DeleteTooltip';

export default DeleteTooltip;
